import { Box, Typography } from '@mui/material';

const NotFoundPage = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight='100vh'
      textAlign='center'
      px={2}
      width='100%'
    >
      <Typography style={{ fontSize: '40px' }} variant='h1' gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant='body1' color='textSecondary'>
        The page you were looking for does not exist or has expired.
      </Typography>
    </Box>
  );
};

export default NotFoundPage;
